import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import type { ProSkillManagerSetModel } from "~~/package/mapper/proSkillManager/model/ProSkillManagerSetModel";
import {
    ProSkillManagerCandidateSummaryModel
} from "~~/package/mapper/proSkillManager/model/summary/ProSkillManagerCandidateSummaryModel";
import { UserStatusType } from "~~/package/mapper/user/model/UserStatusType";
import { ProSkillManagerType } from "~~/package/mapper/proSkillManager/model/ProSkillManagerType";

export class ProSkillAssureAssessmentDataModel extends Model {
    constructor(
        public id: number = 0,
        public name: string = "",
        public title: string = "",
        public userStatus: UserStatusType = UserStatusType.NORMAL,
        public type: ProSkillManagerType = ProSkillManagerType.INTERNAL,
        public isEyeTracking: boolean = false,
        public isTabProctoring: boolean = false,
        public isCopyPasteFlag: boolean = false,
        public isShortcutFlag: boolean = false,
        public isMultiMonitorFlag: boolean = false,
        public isScreenRecordingFlag: boolean = false,
        public useExternalMonitoringFlag: boolean = false,
        public status: string = "",
        public candidateSummary: ProSkillManagerCandidateSummaryModel = new ProSkillManagerCandidateSummaryModel(),
        public totalTime: number = 0,
        public startedAt: string = "",
        public endedAt: string = "",
        public createdAt: string = "",
        public sets: ProSkillManagerSetModel[] = [],
        public noTimeLimit: boolean = true
    ) {
        super();
    }

    public static create(model: Partial<ProSkillAssureAssessmentDataModel>): ProSkillAssureAssessmentDataModel {
        return createModel<ProSkillAssureAssessmentDataModel>(ProSkillAssureAssessmentDataModel, {
            ...model
        });
    }
}
